module.exports = __webpack_public_path__ + "static/media/iip.1e0adcc6.pdf";